import React from 'react';
import { Link, ListItem } from '@mui/material';
import { Heading3, LegalCard, Paragraph, UnorderedList } from './LegalComponents';

export const TermsAndConditionsPage = () => {
  return (
    <LegalCard title="Allgemeine Geschäftsbedingungen (AGB)">
      <Heading3 sx={{ mt: 0 }}>1. Einleitung</Heading3>
      <Paragraph>
        Diese Allgemeinen Geschäftsbedingungen (AGB) legen die Bedingungen fest, unter denen Alloy Ads, ein Produkt der
        Ringier AG (nachfolgend „Anbieterin“ genannt), Dienstleistungen für den Kunden (nachfolgend „Kunde“ genannt)
        erbringt. Die AGB regeln alle Rechtsbeziehungen zwischen der Anbieterin und dem Kunden bezüglich der Alloy
        Ads-Dienstleistungen und bilden einen integralen Bestandteil jedes Vertrags zwischen den Parteien. Die
        Anbieterin behält sich das Recht vor, diese AGB jederzeit zu ändern. Die jeweils aktuelle Version ist unter{' '}
        <Link href="https://app.alloyads.ai/terms-of-service" target="_blank">
          https://app.alloyads.ai/terms-of-service
        </Link>{' '}
        verfügbar.
      </Paragraph>
      <Heading3>2. Vertragsabschluss und Laufzeit</Heading3>
      <Paragraph>Ein Vertrag über Alloy Ads-Dienstleistungen kommt zustande, wenn:</Paragraph>
      <UnorderedList>
        <ListItem disableGutters>
          Die Anbieterin die Anfrage des Kunden auf ein Angebot per E-Mail bestätigt, oder
        </ListItem>
        <ListItem disableGutters>Der Kunde das Angebot der Anbieterin per E-Mail akzeptiert.</ListItem>
      </UnorderedList>
      <Paragraph>
        Der Vertrag wird für eine bestimmte Laufzeit oder bis zur Erschöpfung des vereinbarten Budgets geschlossen. Die
        Laufzeit kann bei Bedarf um bis zu 72 Stunden verlängert werden, sofern keine zwingenden Gründe dagegen
        sprechen. Die Anbieterin behält sich das Recht vor, den Vertrag aus wichtigem Grund fristlos zu kündigen,
        einschliesslich, aber nicht beschränkt auf Verstösse gegen die in diesen AGB festgelegten Pflichten.
      </Paragraph>
      <Heading3>3. Stornierung, Umbuchung und Entschädigung</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          <strong>Stornierung und Umbuchung:</strong> Der Kunde kann eine Dienstleistung nur vor dem Beginn stornieren
          oder umbuchen und muss die Anbieterin sowie etwaige Dritte für bereits erbrachte Leistungen vollständig
          entschädigen. Eine Umbuchung muss mindestens fünf Arbeitstage vor dem ursprünglichen Beginn beantragt werden.
        </ListItem>
        <ListItem disableGutters>
          <strong>Mehrere Aufträge:</strong> Werden mehrere Aufträge zu einem Sammelauftrag zusammengefasst, gelten die
          Bedingungen für einen Grossauftrag. Ein etwaiger Rabatt, der für einen Sammelauftrag gewährt wurde, verfällt,
          wenn das gesamte Budget bis zum Ende der Laufzeit nicht ausgeschöpft wird, und die Differenz wird dem Kunden
          in Rechnung gestellt.
        </ListItem>
        <ListItem disableGutters>
          <strong>Zahlung der Vergütung:</strong> Wurde eine Vergütung vereinbart, erfolgt die Zahlung frühestens 60
          Tage nach Ablauf der Kampagne.
        </ListItem>
      </UnorderedList>
      <Heading3>4. Umfang der von der Anbieterin erbrachten Leistungen</Heading3>
      <Paragraph>
        Die Anbieterin bietet dem Kunden die Möglichkeit, seine Werbung gemäss dem Umfang der Buchung auf verschiedenen
        Kanälen innerhalb einer Kampagne zu steuern. Dies beinhaltet die Veröffentlichung von Werbeinhalten (z.B. Texte,
        Bilder, Logos) auf Drittplattformen und Suchmaschinen (zusammen "Publisher").
      </Paragraph>
      <UnorderedList>
        <ListItem disableGutters>
          <strong>Leistungsbeschreibung:</strong> Die Details der für jede Kampagne erbrachten Dienstleistungen sind im
          Vertrag festgelegt. Angegebene Impressionen oder Reichweiten sind Schätzungen und nicht garantiert. Die
          tatsächlichen Zahlen können je nach Art und Format der vom Kunden gelieferten Werbemittel variieren.
        </ListItem>
        <ListItem disableGutters>
          <strong>Kontenerfordernisse:</strong> Die Veröffentlichung von Werbeinhalten auf bestimmten Plattformen (z.B.
          Google, Facebook) setzt voraus, dass der Kunde ein bestehendes Konto bei diesen Plattformen hat. Die
          Anbieterin kann auf Anfrage den Kunden einmalig bei der Erstellung einer Facebook-Fanpage (FBF) oder eines
          Google My Business Accounts (GBA) unterstützen. Die Verpflichtung der Anbieterin gilt als erfüllt, sobald die
          Administratorrechte an den Kunden übertragen wurden.
        </ListItem>
      </UnorderedList>
      <Heading3>5. Änderungen der Dienstleistungskonfiguration und des Publisher-Netzwerks</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          Die Anbieterin behält sich das Recht vor, die Zusammensetzung der Publisher innerhalb ihres Netzwerks
          jederzeit zu ändern, einschliesslich des Austauschs, der Entfernung oder der Hinzufügung von Publishern
          während der Vertragslaufzeit. Solche Änderungen stellen keinen Vertragsbruch dar und entbinden den Kunden
          nicht von seinen Zahlungspflichten.
        </ListItem>
        <ListItem disableGutters>
          Die Anbieterin wendet branchenübliche Standards an und übt die gebotene Sorgfalt bei der Erbringung ihrer
          Dienstleistungen aus. Sie kann ihre Einrichtungen, technischen Anforderungen oder Dienstleistungsangebote
          jederzeit ohne vorherige Benachrichtigung des Kunden anpassen, sofern solche Änderungen die Leistungsansprüche
          des Kunden nicht unzumutbar beeinträchtigen.
        </ListItem>
      </UnorderedList>
      <Heading3>6. Zugang zum Kundenbereich</Heading3>
      <Paragraph>
        Nach Vertragsschluss erhält der Kunde Zugang zu einem passwortgeschützten Kundenbereich. Die Anbieterin bestimmt
        die Art des Zugangsschutzes und ist nicht verpflichtet, die Identität der Benutzer zu überprüfen. Der Kunde ist
        verpflichtet, seine Passwörter und Identifikationsschlüssel vor Missbrauch zu schützen und haftet für Schäden,
        die aus einem solchen Missbrauch entstehen. Die Anbieterin kann den Zugang zum Kundenbereich bei Missbrauch oder
        Nichtzahlung sperren.
      </Paragraph>
      <Heading3>7. Pflichten des Kunden bezüglich der Werbeinhalte</Heading3>
      <Paragraph>
        Der Kunde ist dafür verantwortlich, dass alle der Anbieterin zur Verfügung gestellten Werbeinhalte:
      </Paragraph>
      <UnorderedList>
        <ListItem disableGutters>
          Rechtzeitig (d.h. mindestens fünf Arbeitstage vor dem ersten Aufschaltdatum) und in einem technisch
          einwandfreien Format bereitgestellt werden.
        </ListItem>
        <ListItem disableGutters>
          Allen geltenden Gesetzen entsprechen und keine Inhalte enthalten, die sexuell, pornografisch, politisch
          radikal sind oder anderweitig gegen die guten Sitten oder Rechte Dritter verstossen.
        </ListItem>
        <ListItem disableGutters>
          Keine Rechte Dritter, einschliesslich geistiger Eigentumsrechte, verletzen und dass der Kunde alle
          erforderlichen Nutzungsrechte im Voraus eingeholt hat.
        </ListItem>
      </UnorderedList>
      <Paragraph>
        Der Kunde erkennt an, dass jeder Publisher eigene Nutzungs- und Datenschutzbestimmungen sowie Werberichtlinien
        hat, und es liegt in der Verantwortung des Kunden, sich über diese Bestimmungen zu informieren und sie
        einzuhalten.
      </Paragraph>
      <Heading3>8. Rechte der Anbieterin bezüglich der Werbeinhalte</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          <strong>Ablehnung oder Löschung von Inhalten:</strong> Die Anbieterin kann nach eigenem Ermessen Werbeinhalte
          des Kunden jederzeit ablehnen oder löschen, wenn diese nicht den oben genannten Anforderungen entsprechen.
          Wird ein Inhalt abgelehnt oder gelöscht, hat der Kunde keinen Anspruch auf Erstattung bereits geleisteter
          Zahlungen, soweit diese dem Wert der bereits erbrachten Leistungen entsprechen.
        </ListItem>
        <ListItem disableGutters>
          <strong>Keine Verpflichtung zur Prüfung von Inhalten:</strong> Die Anbieterin übernimmt keine Verpflichtung
          zur Prüfung der Werbeinhalte und lehnt jegliche Haftung in diesem Zusammenhang ausdrücklich ab. Der Kunde
          stellt die Anbieterin von allen Kosten, einschliesslich der Kosten der Rechtsverteidigung, und Ansprüchen
          Dritter oder Gesetzesverstößen frei, die im Zusammenhang mit den Inhalten gegen die Anbieterin geltend gemacht
          werden.
        </ListItem>
      </UnorderedList>
      <Heading3>9. Geistiges Eigentum und Rechte Dritter</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          Alle geistigen Eigentumsrechte und Eigentumsrechte an den Werbeinhalten verbleiben ausschliesslich bei der
          Anbieterin, sofern der Kunde die Inhalte nicht in fertigem Zustand liefert. Wenn Inhalte von der Anbieterin
          oder einem Dritten bearbeitet werden, gilt diese Regel auch für die bearbeiteten Inhalte.
        </ListItem>
        <ListItem disableGutters>
          Der Kunde räumt der Anbieterin ein exklusives, dauerhaftes, übertragbares, gebührenfreies Recht ein,
          einschliesslich des Rechts zur uneingeschränkten Unterlizenzierung, die Werbeinhalte zu nutzen, zu
          vervielfältigen, zu ändern, anzupassen, zu übersetzen, zu verteilen, zu veröffentlichen und darzustellen.
        </ListItem>
      </UnorderedList>
      <Heading3>10. Datenschutz und Vertraulichkeit</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          <strong>Einhaltung der Datenschutzrichtlinien:</strong> Es gelten die jeweils aktuellen
          Datenschutzbestimmungen der Anbieterin, die unter{' '}
          <Link href="https://app.alloyads.ai/privacy-policy" target="_blank">
            https://app.alloyads.ai/privacy-policy
          </Link>{' '}
          verfügbar sind.
        </ListItem>
        <ListItem disableGutters>
          <strong>Pflichten des Kunden:</strong> Der Kunde muss die geltenden Datenschutzgesetze einhalten und
          sicherstellen, dass er zur Beauftragung der Anbieterin und zur Übermittlung personenbezogener Daten berechtigt
          ist. Der Kunde stellt die Anbieterin von allen Ansprüchen Dritter frei, die im Zusammenhang mit der
          Datenverarbeitung gegen die Anbieterin geltend gemacht werden.
        </ListItem>
        <ListItem disableGutters>
          <strong>Bearbeitung personenbezogener Daten:</strong> Die Anbieterin wird personenbezogene Daten nur zur
          Vertragserfüllung bearbeiten und die notwendigen technischen und organisatorischen Massnahmen zum Schutz der
          Daten umsetzen.
        </ListItem>
      </UnorderedList>
      <Heading3>11. Zahlungsbedingungen</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          Der Kunde hat den vereinbarten Preis innerhalb von 30 Tagen nach Rechnungsdatum ohne Abzüge zu zahlen. Die
          Rechnungsstellung erfolgt in der Regel monatlich, wobei die erste Rechnung unmittelbar nach Vertragsschluss
          erstellt wird.
        </ListItem>
        <ListItem disableGutters>
          Im Falle eines Zahlungsverzugs gilt ein Verzugszins von 5 % p.a. Die Anbieterin kann auch Mahnkosten verlangen
          und den offenen Betrag zum Zweck des Inkassos an Dritte abtreten oder verkaufen.
        </ListItem>
        <ListItem disableGutters>
          Die Anbieterin behält sich das Recht vor, Vorauszahlungen zu verlangen, bevor sie ihre Leistungen erbringt.
          Die Anbieterin kann ihre Leistungen ohne vorherige Benachrichtigung einstellen, wenn der Kunde nicht
          rechtzeitig zahlt.
        </ListItem>
      </UnorderedList>
      <Heading3>12. Haftung und Haftungsbeschränkung</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          Die Haftung der Anbieterin gegenüber dem Kunden ist auf die ordnungsgemässe Erbringung der vertraglich
          vereinbarten Leistungen beschränkt.
        </ListItem>
        <ListItem disableGutters>
          Die Anbieterin haftet nur bei vorsätzlichem oder grob fahrlässigem Verhalten. Jede weitere Haftung ist im
          gesetzlich zulässigen Umfang ausgeschlossen, einschliesslich der Haftung für Einflüsse Dritter (z.B.
          Klickbetrug), indirekte oder Folgeschäden, höhere Gewalt, Streiks und technische Störungen ausserhalb des
          Einflussbereichs der Anbieterin.
        </ListItem>
        <ListItem disableGutters>
          Die Haftung der Anbieterin ist, soweit sie besteht, auf den nachgewiesenen Schaden begrenzt, jedoch in keinem
          Fall höher als die Vertragssumme.
        </ListItem>
      </UnorderedList>
      <Heading3>13. Schlussbestimmungen</Heading3>
      <UnorderedList>
        <ListItem disableGutters>
          <strong>Änderungen:</strong> Änderungen, Ergänzungen oder Zusatzvereinbarungen zu diesen AGB sind nur gültig,
          wenn sie schriftlich erfolgen oder – im Fall elektronischer Kommunikation – von der Anbieterin per E-Mail
          bestätigt werden, wobei eine einfache e-Signatur oder eine eingescannte Unterschrift ausreichend ist.
        </ListItem>
        <ListItem disableGutters>
          <strong>Abtretung:</strong> Die Anbieterin ist berechtigt, ihre Rechte und Pflichten aus dem Vertrag jederzeit
          auf einen Dritten zu übertragen. Der Kunde darf seine Rechte oder Pflichten ohne vorherige schriftliche
          Zustimmung der Anbieterin nicht abtreten.
        </ListItem>
        <ListItem disableGutters>
          <strong>Änderungen im Status des Kunden:</strong> Änderungen im rechtlichen Status des Kunden berühren nicht
          die Gültigkeit des Vertrags. Bei Betriebseinstellung des Kunden ist die Anbieterin berechtigt, den noch
          offenen Vertragssaldo sofort in Rechnung zu stellen.
        </ListItem>
        <ListItem disableGutters>
          <strong>Anwendbares Recht und Gerichtsstand:</strong> Der Vertrag unterliegt schweizerischem Recht, unter
          Ausschluss der Kollisionsnormen und des Übereinkommens der Vereinten Nationen über Verträge über den
          internationalen Warenkauf (CISG). Gerichtsstand ist Zürich, Schweiz.
        </ListItem>
      </UnorderedList>
      <Heading3>Ringier AG, May 2025</Heading3>
    </LegalCard>
  );
};
